import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSeo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={23} fill='none' {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M13.112 1.037c6.932-.87-.108 8.373-2.365 5.79-.68-.842.11-3.099 1.93-2.908-3.126 3.37 2.8 2.555 1.74-.68-.815-1.55-3.126-.707-4.132.027-2.12 1.55-3.887 6.688.761 6.77 4.16.108 10.195-3.67 14.354-3.236 1.74-.027 2.718 1.142 3.778 2.284-2.582-8.7-10.765-10.575-16.066-8.047'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M9.605 19.414c2.556.245 7.041-.87 9.705-1.44.816-1.578 1.55-1.93 1.74-2.339l.979-3.37 3.37-1.278c.517-.19-2.582-1.196-10.928 1.74-1.604.407-4.268 1.114-5.79.217-2.31-1.332-1.713-3.914-1.767-4.866-.136 1.495-.979 2.773 0 6.416.816 3.044 2.12 3.887 2.691 4.92'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='m25.372 2.152 1.36 1.305c1.141-.082 9.378-1.44 7.203 1.984-2.419 3.806-11.499 7.123-11.526 7.15l-.897 2.936c4.486-1.36 10.412-4.893 13.647-7.34 13.211-10.548-8.237-6.742-9.787-6.035'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M8.6 19.876c-8.998 0-3.725-5.192-2.583-6.36v-1.713c-1.332.951-3.017 2.69-4.023 3.914C.689 17.294-.371 19.74 2.13 20.8c4.757 2.04 15.141-.135 20.17-2.12 4.513-1.767 6.58-3.017 10.494-5.464.87-.544 5.41-3.969 5.926-4.784-4.214 3.126-8.02 5.844-13.918 8.182-4.132 1.631-11.336 3.262-16.202 3.262M20.615 19.686c.924 2.093 6.388 1.25 7.584-3.317A41 41 0 0 1 24.91 18c-.08.3-.434.625-.896.761a1.73 1.73 0 0 1-.979.027c-.244.11-.49.19-.734.3-.516.19-1.087.38-1.685.598'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M12.487 21.589c2.04.897 3.806 1.55 6.225 1.386.517-.027 1.795-.109 2.257-.435-1.25-.027-2.039-.76-2.284-2.283a51 51 0 0 1-6.198 1.332M24.883 14.766c.299.244.652.543.734 1.141.272-.108.516-.217.788-.326.68-.299 1.305-.625 1.985-.924.081-.027.136-.082.217-.109l-.326-1.468-.082.027a42 42 0 0 1-3.316 1.659M20.588 17.593c.027 0 .081 0 .163-.027a49 49 0 0 0 3.344-1.06c-.517-.408-1.441-.599-2.202-.245-.626.299-1.033.788-1.305 1.332'
      clipRule='evenodd'
    />
  </svg>
);
export default SvgSeo;
